import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreditCard from "./boxes/CreditCard/CreditCard";
import classes from "./ClientCreditCards.module.scss";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { Skeleton } from "../../../../shared/Skeleton/Skeleton";
import { Button } from "../../../../shared/Button/Button";
import { svg } from "../../../../assets/svg";
import AddEditCardModal from "./shared/AddEditCardModal/AddEditCardModal";
import { getSetupIntent } from "../../../../Actions/Stripe/StripeActions";
import { USER_PAYMENT_SYSTEMS } from "../../../../consts/api";
import { usePatientPaymentMethods } from "../../../../hooks/usePatientPaymentMethods";

const ClientCreditCards = ({ clientId, getSetupIntent, clientClinicId }) => {
  const { tCommon } = useAppTranslation.Common();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const pms = usePatientPaymentMethods({ patientId: clientId });

  const isEmpty = !pms.isLoading && pms.data?.length === 0;
  const isVisible = !pms.isLoading && !isEmpty;
  const isAddBtnVisible = pms.canAdd && pms.isPosEnabled;

  const openAddModal = () => {
    setIsAddModalOpen(true);
    if (pms.paymentSystem === USER_PAYMENT_SYSTEMS.stripe) {
      getSetupIntent({ patient_id: clientId, clinic_id: clientClinicId });
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.cards}>
        {pms.isLoading && <Skeleton count={3} height={25} borderRadius="4px" />}
        {isEmpty && (
          <div className={classes.empty}>{tCommon("label.noCreditCards")}</div>
        )}
        {isVisible &&
          pms.data.map((card) => (
            <CreditCard
              key={card.id}
              id={
                pms.paymentSystem === USER_PAYMENT_SYSTEMS.clearent
                  ? card.extra.dbId
                  : card.id
              }
              cardNumber={card.cardNumber}
              isPrimary={card.isPrimary}
              clientId={clientId}
              clientClinicId={clientClinicId}
            />
          ))}
      </div>
      {isAddBtnVisible && (
        <Button
          widthFit
          variant="text"
          size="tiny"
          leftAdornment={<img src={svg.plusPrimary} alt="+" width="11px" />}
          onClick={() => openAddModal()}
        >
          {tCommon("label.addCC")}
        </Button>
      )}
      {isAddModalOpen && (
        <AddEditCardModal
          clientId={clientId}
          isOpen={isAddModalOpen}
          onClose={() => setIsAddModalOpen(false)}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getSetupIntent,
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(ClientCreditCards);
